/**
 * 入口
 */

import "@/util/budo_log.js";

import "@/util/budo-mall-css.css";

import Vue from "vue";
import App from "./App.vue";
import Vant from "vant";
import { Toast } from "vant";
import "vant/lib/index.css";
import store from "./store";
import axios from "./util/axios";
import VueAxios from "vue-axios";
import VueRouter from "vue-router";
import { _validate_null_ } from "@/util/validate";
import VueWechatTitle from "vue-wechat-title";
import VueMoment from "vue-moment";
import Moment from "moment";
import { router } from "@/router";
import { $go_wx_auth_url } from "@/util/wxSdk";
import { $is_quick_authorize_redirect } from "./page-url-conf.js";

import { Dialog } from "vant";

import {
  expressStatusFilter,
  moneyFilter,
  moneyFormatFilter,
  orderPayStatusFilter,
  orderStatusFilter,
} from "@/filters/filters";

import search from "@/components/common/search";
Vue.component("search", search);

import PageBack from "@/components/PageBack";
Vue.component("PageBack", PageBack);

import BackToAct from "@/components/BackToAct";
Vue.component("BackToAct", BackToAct);

import BudoPopup from "@/components/BudoPopup";
Vue.component("BudoPopup", BudoPopup);

import IndexCateListNew from "@/components/IndexCateListNew";
Vue.component("IndexCateListNew", IndexCateListNew);

Vue.config.productionTip = false;

Vue.use(Vant);
Vue.use(VueRouter);
Vue.use(VueWechatTitle);
Vue.use(VueMoment);

window.axios = axios;
Vue.use(VueAxios, axios);

window.$budo_toast = function (text) {
  Toast(text);
};

window.$budo_alert = function (text) {
  Dialog.alert({ message: text });
};

Vue.prototype.get_mall_module_topCateId = function () {
  var mall_module = this.$store.getters.mall_module;
  return mall_module ? mall_module.topCateId : null;
};

Vue.prototype.get_mall_module_name = function () {
  var mall_module = this.$store.getters.mall_module;
  return mall_module ? mall_module.name : null;
};

Vue.prototype.get_mall_module = function () {
  var mall_module = this.$store.getters.mall_module;
  return mall_module ? mall_module : {};
};

Vue.filter("money", moneyFilter);
Vue.filter("moneyFormatFilter", moneyFormatFilter);
Vue.filter("orderStatusFilter", orderStatusFilter);
Vue.filter("payStatusFilter", orderPayStatusFilter);
Vue.filter("expressStatusFilter", expressStatusFilter);

Vue.filter("formatDate", function (value) {
  return Moment(value).format("YYYY-MM-DD HH:mm");
});

Vue.filter("formatLocalDate", function (value) {
  return Moment(value).format("YYYY-MM-DD");
});

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

import waterMark from "@/util/waterMark";
if (
  location.href.includes("500.cdhuanying.com") ||
  location.href.includes("ls.cdhuanying.com")
) {
  setTimeout(() => {
    waterMark.set("测试MAL");
  }, 500);
}

router.afterEach(() => { // 暂存一下
  window["_location_href_"] = location.href;
})

router.beforeEach((to, from, next) => {
  budo_log.debug("#148 router beforeEach", to, from);

  Vue.prototype.$EventBus = new Vue();

  if (to.meta.title) {
    document.title = to.meta.title;
  }

  if (
    to.path === "/seckill-public" ||
    to.path === "/seckill-goods-detail"
  ) {
    next();
    return;
  }

  if (to.path === "/public") {
    next();
  }

  const notTabBar = [
    "/card-mobile-bind",
    "/bind-mobile",
    "/bind-card",
    "/home",
    "/movie",
    "/seckill-detail",
  ];

  if (notTabBar.findIndex((v) => v === to.path) >= 0) {
    store.commit("SET_VISIBLE_TABBAR", false);
  } else {
    store.commit("SET_VISIBLE_TABBAR", true);
  }

  // budo_log.info("#162 next", from, to)
  next();
});

// 这个页面 如无 sessionStorage access_token 就快速跳登录 不待接口相应再跳 视觉效果更优
var v4_token_mall = sessionStorage.getItem("budo.v4_token_mall");
if (!v4_token_mall && $is_quick_authorize_redirect()) {
  budo_log.debug("#119 no v4_token_mall in sessionStorage", location);

  var redirectUrl = location.pathname + location.search + location.hash;
  $go_wx_auth_url(redirectUrl);
} else {
  new Vue({
    router,
    store,
    render: (h) => h(App),
  }).$mount("#app");
}
